export default __webpack_public_path__ + "static/media/screen-magnet-finder-min.6e01e9bd.png";